

















































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import moment from "moment";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() stadiumGrounds!: any[];

  @Prop() allowHalfAnHour!: boolean;

  chooseDate() {
    // 选择日期
  }

  disabledDate(current: any) {
    // Can not select days before today and today
    return (
      current &&
      current <=
        moment()
          .subtract(1, "day")
          .endOf("day")
    );
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            values.time_date_start = values.time_date_day[0].format("YYYY-MM-DD");
            values.time_date_end = values.time_date_day[1].format("YYYY-MM-DD");
            delete values.time_date_day;
            // console.log(values)
            const res = await this.$store.dispatch("stadium/orderedGround", {
              stadium_id: this.stadiumId,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  validateToTimeStart(rule: any, value: any, callback: any) {
    const { form } = this;

    let time_start = form.getFieldValue("time_start");
    if (parseInt(time_start, 10) < 10) {
      time_start = "0" + time_start;
    }
    let minute_start = form.getFieldValue("minute_start");
    let time_end = form.getFieldValue("time_end");
    if (parseInt(time_end, 10) < 10) {
      time_end = "0" + time_end;
    }
    let minute_end = form.getFieldValue("minute_end");

    const starttime = moment(time_start + ":" + minute_start, "HH:mm");
    const endtime = moment(time_end + ":" + minute_end, "HH:mm");

    if (!starttime.isBefore(endtime)) {
      callback("结束时间要大于开始时间");
    } else {
      // form.validateFields(["time_start"]);
      callback();
    }
  }

  validateToTimeEnd(rule: any, value: any, callback: any) {
    const { form } = this;

    let time_start = form.getFieldValue("time_start");
    if (parseInt(time_start, 10) < 10) {
      time_start = "0" + time_start;
    }
    let minute_start = form.getFieldValue("minute_start");

    let time_end = form.getFieldValue("time_end");
    if (parseInt(time_end, 10) < 10) {
      time_end = "0" + time_end;
    }
    let minute_end = form.getFieldValue("minute_end");

    const starttime = moment(time_start + ":" + minute_start, "HH:mm");
    const endtime = moment(time_end + ":" + minute_end, "HH:mm");

    if (!starttime.isBefore(endtime)) {
      callback("结束时间要大于开始时间");
    } else {
      // form.validateFields(["time_end"]);
      callback();
    }
  }

  renderWeeks(){
    var weeks=this.form.getFieldValue("weeks");
    if(weeks==undefined){
      return 0
    }
    return weeks.length
  }

}
